<template>
  <div class="row mb-5rem">
    <div
      class="rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center position-absolute"
      :class="variant"
    >
      <i :class="iconClass"></i>

      <p class="font-weight-normal my-auto ml-3">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalloutAlert',
  props: {
    iconClass: {
      type: String,
      default: 'font-24 mx-3 ml-lg-2',
    },
    message: {
      type: String,
      default: 'alerta',
    },
    variant: {
      type: String,
      default: 'info',
    },
  },
}
</script>

<style lang="scss" scoped>
.rb-alert {
  top: 97%;
  left: 0;
  width: 100%;
  padding: 10px 0;
}

.info {
  background-color: #feeeb7;

  & p,
  i {
    color: #af6717;
  }
}

.warning {
  background-color: #fdeee8;

  & p,
  i {
    color: #af4208;
  }
}

.success {
  background-color: #d0f0e0;

  & a {
    color: #0d764d;
  }

  & p,
  i {
    color: #0d764d;
  }
}

.danger {
  background-color: #ffebeb;

  & p,
  i {
    color: #ff5b5c;
  }
}

.mb-5rem {
  margin-bottom: 5rem !important;
}
</style>
